export default {
  getInteriorCondition: (axios, digitalCertificateId) =>
    axios.get(
      `/api/digitalCertificates/${digitalCertificateId}/interiorCondition`,
    ),
  saveInteriorCondition: (axios, digitalCertificateId, data) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/interiorCondition`,
      data,
    ),
  deleteInteriorConditionElement: (
    axios,
    digitalCertificateId,
    interiorElementId,
  ) =>
    axios.delete(
      `/api/digitalCertificates/${digitalCertificateId}/interiorCondition/${interiorElementId}`,
    ),
  saveInteriorConditionImage: (
    axios,
    digitalCertificateId,
    interiorElementId,
    data,
  ) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/interiorCondition/${interiorElementId}/image`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    ),
  deleteInteriorConditionImage: (
    axios,
    digitalCertificateId,
    interiorElementId,
    imageId,
  ) =>
    axios.delete(
      `/api/digitalCertificates/${digitalCertificateId}/interiorCondition/${interiorElementId}/image/${imageId}`,
    ),
}
